import { render, staticRenderFns } from "./DownloadDialog.vue?vue&type=template&id=86871ed6&scoped=true&"
import script from "./DownloadDialog.vue?vue&type=script&lang=js&"
export * from "./DownloadDialog.vue?vue&type=script&lang=js&"
import style0 from "./DownloadDialog.vue?vue&type=style&index=0&id=86871ed6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86871ed6",
  null
  
)

export default component.exports